export const MISSED = 'MISSED'
export const SUCCESS = 'SUCCESS'
export const HOLD = 'HOLD'
export const PAYMENT = 'PAYMENT'
export const ISSUE = 'ISSUE'
export const LOGIST = 'LOGIST'
export const ACTIVE = 'ACTIVE'
